import React from 'react';
import { FolderAddIcon } from '../../../images';
import { Button } from 'src/components/design-system';
import styles from './add-section-button.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';

const AddSectionButton = ({ onClick }) => {
  const lang = useSelector(getLang('CALL_TO_ACTION'));

  return (
    <div className={styles.root}>
      <h2 className={styles.callToAction}>{lang.ADD_SECTION}</h2>
      <Button
        className={styles.button}
        type="primary"
        size="large"
        onClick={onClick}
        data-key="add-first-section-button"
        data-testid="add-section-button"
        icon={<img className={styles.icon} src={FolderAddIcon} alt={lang.ADD_SECTION_BUTTON} />}
      >
        {lang.ADD_SECTION_BUTTON}
      </Button>
    </div>
  );
};

export { AddSectionButton };
